import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWorkerEmployee = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "workerEmployee",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		id: "Path_12459",
		"data-name": "Path 12459",
		d: "M0,0H24V24H0Z",
		fill: "none"
	}), /* @__PURE__ */ _jsxs("g", {
		id: "Group_16617",
		"data-name": "Group 16617",
		transform: "translate(0 -1.526)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12463",
				"data-name": "Path 12463",
				d: "M18.091,7.849l2.2-3.353A1,1,0,0,0,19.42,3H16.009a1,1,0,0,0-.868.5l-3,4.345",
				transform: "translate(0 1.052)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12464",
				"data-name": "Path 12464",
				d: "M5.7,7.71,3.712,4.5A1,1,0,0,1,4.58,3H7.991a1,1,0,0,1,.868.5L11.627,7.71",
				transform: "translate(0 1.052)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_16613",
				"data-name": "Group 16613",
				transform: "translate(0 4)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_12467",
					"data-name": "Path 12467",
					d: "M19,19H5a3,3,0,0,1-3-3V8A3,3,0,0,1,5,5H19a3,3,0,0,1,3,3v8A3,3,0,0,1,19,19Z",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12474",
				"data-name": "Path 12474",
				d: "M13.84,15H8",
				transform: "translate(4.5)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12475",
				"data-name": "Path 12475",
				d: "M14,18H10",
				transform: "translate(2.5)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse_637",
				"data-name": "Ellipse 637",
				cx: 2.5,
				cy: 2.5,
				r: 2.5,
				transform: "translate(5 14)",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5
			})
		]
	})]
});
export default SvgWorkerEmployee;
